<template>
    <label class="flex font-medium text-gray-700 cursor-pointer pb-2">
        <input 
            class="rounded border-gray-300 text-primary shadow-sm focus:border-primary focus:ring focus:ring-primary-light focus:ring-opacity-50 mt-1"
            type="checkbox" 
            :name="name"
            :value="value" 
            v-model="proxyChecked"
        >
        <span class="ml-2 text-gray-600">
            <slot></slot>
        </span>
    </label>
</template>

<script>
export default {
    emits: ['update:checked'],

    props: {
        name: {
            type: String,
            default: '',
        },
        checked: {
            type: [Array, Boolean],
            default: false,
        },
        value: {
            default: 1,
        },
    },

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
    },
}
</script>
